import baseURL from "@/utils/config";
import request from "@/plugins/axios"

// 获取药品单URL
export function getMedicineBillUrl(data) {
  return request({
    url: `${baseURL.api}/authapi/order/getMedicineBillUrl`,
    method: "post",
    data
  });
}

// 下载药品单
export function medicineBillDownByOrderNo(data) {
  return request({
    url: `${baseURL.api}/authapi/order/medicineBillDownByOrderNo`,
    method: "post",
    data
  });
}

// 上传药品单
export function medicineBillUpload(formData) {
  return request({
    url: `${baseURL.api}/authapi/order/medicineBillUpload`,
    method: "post",
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
} 